import { TooltipPlacement } from './Tooltip';
const SPACING = 8;
const _calculateHorizontalPlacement = (placement, containerX, containerWidth, tooltipWidth) => {
    switch (placement) {
        case TooltipPlacement.TOP_END:
        case TooltipPlacement.BOTTOM_END:
            return containerX + containerWidth - tooltipWidth;
        case TooltipPlacement.TOP:
        case TooltipPlacement.BOTTOM:
            return containerX + containerWidth / 2 - tooltipWidth / 2;
        case TooltipPlacement.RIGHT_END:
        case TooltipPlacement.RIGHT_START:
        case TooltipPlacement.RIGHT:
            return containerX + containerWidth + SPACING;
        case TooltipPlacement.LEFT_END:
        case TooltipPlacement.LEFT_START:
        case TooltipPlacement.LEFT:
            return containerX - SPACING - tooltipWidth;
        case TooltipPlacement.TOP_START:
        case TooltipPlacement.BOTTOM_START:
        default:
            return containerX;
    }
};
const _calculateVerticalPlacement = (placement, containerY, containerHeight, tooltipHeight) => {
    switch (placement) {
        case TooltipPlacement.TOP_END:
        case TooltipPlacement.TOP_START:
        case TooltipPlacement.TOP:
            return containerY - SPACING - tooltipHeight;
        case TooltipPlacement.RIGHT_END:
        case TooltipPlacement.LEFT_END:
            return containerY + containerHeight - tooltipHeight;
        case TooltipPlacement.RIGHT:
        case TooltipPlacement.LEFT:
            return containerY + containerHeight / 2 - tooltipHeight / 2;
        case TooltipPlacement.BOTTOM_END:
        case TooltipPlacement.BOTTOM_START:
        case TooltipPlacement.BOTTOM:
            return containerY + containerHeight + SPACING;
        case TooltipPlacement.RIGHT_START:
        case TooltipPlacement.LEFT_START:
        default:
            return containerY;
    }
};
const _needsReplacement = (placement, tooltipRef, containerRef) => {
    var _a, _b, _c, _d;
    const { x: containerX, y: containerY, width: containerWidth, height: containerHeight, } = (_b = (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : {};
    const { width: tooltipWidth, height: tooltipHeight } = (_d = (_c = tooltipRef === null || tooltipRef === void 0 ? void 0 : tooltipRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect()) !== null && _d !== void 0 ? _d : {};
    const left = _calculateHorizontalPlacement(placement, containerX, containerWidth, tooltipWidth);
    const top = _calculateVerticalPlacement(placement, containerY, containerHeight, tooltipHeight);
    const right = left + tooltipWidth;
    const bottom = top + tooltipHeight;
    return (top < 0 ||
        right > window.innerWidth ||
        bottom > window.innerHeight ||
        left < 0);
};
export const findReplacement = (originalPlacement, tooltipRef, containerRef) => {
    var _a;
    const orderedPlacements = [
        TooltipPlacement.TOP_START,
        TooltipPlacement.TOP,
        TooltipPlacement.TOP_END,
        TooltipPlacement.RIGHT_START,
        TooltipPlacement.RIGHT,
        TooltipPlacement.RIGHT_END,
        TooltipPlacement.BOTTOM_START,
        TooltipPlacement.BOTTOM,
        TooltipPlacement.BOTTOM_END,
        TooltipPlacement.LEFT_START,
        TooltipPlacement.LEFT,
        TooltipPlacement.LEFT_END,
    ];
    const originalPlacementIndex = orderedPlacements.findIndex((placement) => placement === originalPlacement);
    return ((_a = (originalPlacementIndex >= 0 &&
        orderedPlacements
            .slice(originalPlacementIndex)
            .concat(orderedPlacements.slice(0, originalPlacementIndex))
            .find((placement) => !_needsReplacement(placement, tooltipRef, containerRef)))) !== null && _a !== void 0 ? _a : originalPlacement);
};
